<div class="mainOrderReceipt">
  <router-outlet></router-outlet>
</div>